import React from "react";
import { Popover, Typography, Space } from "antd";
import { IMultiLanguage } from "../../../types/MutliLanguage";

interface MultiLanguagePopoverProps {
  value: IMultiLanguage;
  trigger?: "hover" | "click";
}

const TitlePopOver: React.FC<MultiLanguagePopoverProps> = ({
  value,
  trigger = "hover",
}) => {
  const content = (
    <Space direction="vertical" size="small">
      <Typography.Text strong>Arabic:</Typography.Text>
      <Typography.Text>{value.Ar || "-"}</Typography.Text>
      <Typography.Text strong>French:</Typography.Text>
      <Typography.Text>{value.Fr || "-"}</Typography.Text>
    </Space>
  );

  return (
    <Popover content={content} title="Translations" trigger={trigger}>
      <Typography.Text>{value.En}</Typography.Text>
    </Popover>
  );
};

export default TitlePopOver;
